import React from 'react';

import { List, ListItem, Modal, Title } from '@icarros/ids-react';
import { ReactComponent as Cadeado } from '../../../assets/rebranding/objetos/cadeado.svg';
import { ModalBodyWrapper } from './style';

function ModalBody(): JSX.Element {
  return (
    <ModalBodyWrapper>
      <div>
        <Cadeado style={{ margin: '16px 24px', height: '64px', width: '64px' }} />
        <Title>Dicas do icarros para ter uma venda ainda mais segura</Title>
      </div>
      <List>
        <ListItem
          avatarVariant="icon"
          avatarIcon="itaufonts_senha"
          avatarIconProperties={{
            variant: 'secondary'
          }}
          AvatarSize="medium"
          label="O icarros nunca pedirá informações sensíveis"
          subLabel="Por isso, se entrarem em contato em nome do icarros é golpe! Nunca compartilhe suas senhas, PINs, protocolos de atendimento ou códigos (SMS, e-mail ou WhatsApp)"
        />
        <ListItem
          avatarVariant="icon"
          avatarIcon="itaufonts_sms_mensagem_chat"
          avatarIconProperties={{
            variant: 'secondary'
          }}
          AvatarSize="medium"
          label="Nunca enviaremos protocolos de atendimento por SMS"
        />
        <ListItem
          avatarVariant="icon"
          avatarIcon="itaufonts_telefone"
          avatarIconProperties={{
            variant: 'secondary'
          }}
          AvatarSize="medium"
          label="Não confie em propostas feitas em nome da empresa icarros"
          subLabel="Nós não entraremos em contato para fazer propostas, nem em nome de possíveis compradores"
        />
        <ListItem
          avatarVariant="icon"
          avatarIcon="itaufonts_seg_patrimonial"
          avatarIconProperties={{
            variant: 'secondary'
          }}
          AvatarSize="medium"
          label="Os dados pessoais cadastrados no icarros estarão sempre seguros!"
          subLabel="Nós garantimos um nível de segurança com o certificado de validação avançada (EV SSL)"
        />
        <ListItem
          avatarVariant="icon"
          avatarIconProperties={{
            variant: 'secondary'
          }}
          AvatarSize="medium"
          avatarIcon="itaufonts_brilhos_nos_olhos"
          label="Sua segurança é importante pra nós!"
          hasLine={false}
        />
      </List>
    </ModalBodyWrapper>
  );
}

export function PhoneScamModal({
  modalOpen,
  handleState,
  handleClose,
  handleMainClick
}: Readonly<{
  modalOpen: boolean;
  handleState: () => void;
  handleClose: () => void;
  handleMainClick: () => void;
}>): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, () => handleState()]}
      onClose={handleClose}
      modalType="vertical"
      body={<ModalBody />}
      stickyFooter
      mainButtonText="Entendi"
      mainButtonMethod={() => {
        handleMainClick();
        handleState();
      }}
    />
  );
}
